/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import { 
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    ListSubheader,
    ListItemIcon,
    Checkbox 
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import colors from '../../../../../../constants/colors';


const ACDList = ({ itemList, handleItemList, itemIconList, placeholder }) => {
    const useStyles = makeStyles(() => ({
        ListItemButton: {
            '&:hover': {
                backgroundColor: itemIconList && 'transparent !important',
            },
        },
        subheader: {
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: colors.disabled,
            fontSize: '1rem',
            padding: '0 15px',
            color: 'black'
        },
        subheaderTitle: {
            lineHeight: '10px'
        },
        placeholder: {
            fontSize: '10px',
            color: 'gray',
            padding: '1rem',
            margin: 0
        }
    }));
    const classes = useStyles();

    return (
        <>
            <List
                subheader={
                    <ListSubheader
                        color='primary'
                        inset
                        className={classes.subheader}
                    >
                        <p className={classes.subheaderTitle}>ACD State</p>
                        <p className={classes.subheaderTitle}>ACD Detail</p>
                    </ListSubheader>
                }
            >
                {!itemList.length ? <p className={classes.placeholder}>{placeholder}</p> : itemList.map(item => {
                    const labelId = `list-label-${item.mappingKey}`;
                    return (
                        <ListItem
                            key={item.mappingKey}
                            button
                            onClick={() => handleItemList(item)}
                            className={classes.ListItemButton}
                        >
                            {itemIconList && <ListItemIcon>
                                <Checkbox
                                    edge='start'
                                    checked
                                    tabIndex={-1}
                                    disableRipple
                                    onChange={() => handleItemList(item)}
                                />
                            </ListItemIcon>}
                            <ListItemText
                                id={labelId}
                                primary={item.MappedCode}
                            />
                            <ListItemSecondaryAction>
                                <ListItemText
                                    id={labelId}
                                    primary={item.Detail}
                                />
                            </ListItemSecondaryAction>
                        </ListItem>
                    )
                })}
            </List>
        </>
    )
}

ACDList.propTypes = {
    itemList: PropTypes.array.isRequired,
    handleItemList: PropTypes.func.isRequired,
    itemIconList: PropTypes.bool,
    placeholder: PropTypes.string.isRequired
};

ACDList.defaultProps = {
    itemIconList: false
};

export default ACDList;